import { defineMessages } from 'react-intl';

export const titleMessages = defineMessages({
    mr: { id: '_.name_field.mr', defaultMessage: 'Mr' },
    ms: { id: '_.name_field.ms', defaultMessage: 'Ms' },
    mrs: { id: '_.name_field.mrs', defaultMessage: 'Mrs' },
    miss: { id: '_.name_field.miss', defaultMessage: 'Miss' },
    doctor: { id: '_.name_field.doctor', defaultMessage: 'Doctor' },
    professor: {
        id: '_.name_field.professor',
        defaultMessage: 'Professor'
    },
    sir: { id: '_.name_field.sir', defaultMessage: 'Sir' },
    lord: { id: '_.name_field.lord', defaultMessage: 'Lord' },
    lady: { id: '_.name_field.lady', defaultMessage: 'Lady' },
    baron: { id: '_.name_field.baron', defaultMessage: 'Baron' },
    baroness: { id: '_.name_field.baroness', defaultMessage: 'Baroness' },
    rev: { id: '_.name_field.reverend', defaultMessage: 'Reverend' }
});

export const titles = [
    { value: 'mr', messageKey: 'mr' as const },
    { value: 'ms', messageKey: 'ms' as const },
    { value: 'mrs', messageKey: 'mrs' as const },
    { value: 'miss', messageKey: 'miss' as const },
    { value: 'doctor', messageKey: 'doctor' as const },
    { value: 'professor', messageKey: 'professor' as const },
    { value: 'sir', messageKey: 'sir' as const },
    { value: 'lord', messageKey: 'lord' as const },
    { value: 'lady', messageKey: 'lady' as const },
    { value: 'baron', messageKey: 'baron' as const },
    { value: 'baroness', messageKey: 'baroness' as const },
    { value: 'rev', messageKey: 'rev' as const }
];

export const titlesDE = [
    { value: 'herr', mappedValue: 'mr', label: 'Herr' },
    { value: 'frau', mappedValue: 'mrs', label: 'Frau' }
];
